/**
 * crossFade - change the look of the whole screen, and have the old look
 * ease into the new instead of snapping.
 *
 * A livery is nothing but the theme's colour tokens (livery.css). They are
 * registered properties, so the browser can tween them: while a crossing is
 * ARMED (`data-crossing` on the root, for `ms`) the root eases every token
 * from the old value to the new, and everything painted from them follows.
 * The page is live throughout - this replaced a View Transition (2026-11-04),
 * during which Chromium sends every click to the page root: the table's
 * clicks were lost for as long as each fade played, up to 1.8 s.
 *
 * What is not a colour token (layout, a panel appearing) changes at once.
 * A second crossing during the first eases on from where the first had got
 * to, for its own length.
 *
 * @param {number} ms - the fade's length; 0 for none
 * @param {() => void} change - writes the new look (synchronously)
 */
let disarm = null;

export function crossFade(ms, change) {
  if (!(ms > 0) || typeof document === 'undefined') return change();
  const root = document.documentElement;
  // Armed BEFORE the change, in the same style update: a transition reads the
  // style after the change, which must already ask for the easing.
  root.style.setProperty('--cross-ms', `${ms}ms`);
  root.dataset.crossing = 'true';
  change();
  clearTimeout(disarm);
  disarm = setTimeout(() => delete root.dataset.crossing, ms);
}
